export const infoMock = {
  releaseDate: '07_10_2020',
  version: '1.2.1',
};
